export default __webpack_public_path__ + "static/media/cert-english-work.255af14d.png";